import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Registration,CloneRegistrationUcid } from '../models/registration.model';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FormRegistrationService {

  private lineServiceUrl: string = environment.endpointBackend + '/api/line';
  constructor(private http: HttpClient ) { }

  apiRegistration(payload: Registration): Observable<PayloadResponse<null>>{
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/insert/registration', payload)
    .pipe(
      map(
        response => response.response_code === ResponseStatus.SUCCESS ? response.payload : null 
      )
    )
  }

  apiCloneRegistrationUcid(payload: CloneRegistrationUcid): Observable<PayloadResponse<null>>{
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/insert/cloneRegistrationUcid', payload)
    .pipe(
      map(
        response => response.response_code === ResponseStatus.SUCCESS ? response.payload : null 
      )
    )
  }
}
